<style scoped>
@import "./index.css";
</style>

<template>

    <div id="layout-container">
        <Row >
            <Col>
                <Card  :bordered="false" :dis-hover="true" >
                    <div  slot="title">
                        <span >用户手册</span>
                    </div>
                    <div  >
                        <div v-html="con.content"></div>
                    </div>
                </Card>
            </Col>
        </Row>
    </div>
</template>

<script>
export default {
    data() {
        return {
            imgSrc:this.$func.imgSrc,
            con:''
        }
    },
    created() {
        const that = this;
        that.$func.ajax('listGuide',
        {
            type:'1'
        },function(r){
            if(!r.statusCode){
                that.$func.msg(r.message,'error');
            }else{
                that.$func.ajax('detailGuide',
                    {
                        id:r.type[0].id
                    },function(r){
                        if(!r.statusCode){
                            that.$func.msg(r.message,'error');
                        }else{
                            that.con = r.type;
                        }
                    })
            }
        })
    },
    methods: {

    }
};
</script>
